package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2024_04_19_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We return to our heroes who had recently reached Zedj. Now they head out to investigate the strange and demonic happenings.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("While the heroes approach an old flat-roofed structure, Tuesday spots an eye looking at him from inside the building. Suddenly two creatures pop into existence. These creates are attractive, tall humanoid women from the waist up with six arms (each hand holding a sword) and from the waist down they are serpents.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes bravely attack. During the battle, a beam of energy momentarily connects the two serpentine demons. Tuesday turns Annette and Falorn into Tyrannosaurus Rexes, and they mindlessly finish off the demons and rampage the abandoned old building.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("After Annette’s thirst for property damage has been quenched, and she returns to her original diminutive form, the heroes find a deep hole in the building with a ladder which has fallen into the hole.")
    }
}
